import { useEffect, useRef } from 'react';

const HEADER_OFFSET = 40;

function useHeaderTabsScroll() {
    const scrollElementRef = useRef();
    useEffect(() => {
        //scroll if part of tab is out of viewport
        if (
            scrollElementRef.current &&
            (scrollElementRef.current.offsetLeft + scrollElementRef.current.offsetWidth >
                window.innerWidth - HEADER_OFFSET ||
                scrollElementRef.current.parentElement.scrollLeft > scrollElementRef.current.offsetLeft - HEADER_OFFSET)
        ) {
            scrollElementRef.current.parentElement.scrollLeft = scrollElementRef.current.offsetLeft - HEADER_OFFSET;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollElementRef.current]);

    return scrollElementRef;
}

export default useHeaderTabsScroll;
